import {imageMap} from "../../images/imageMap.ts";
import {Link} from "react-router-dom";
import Icon from "../../components/selfcare/Icon.tsx";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import Routing from "../../Routing.ts";
import TrustBox from "../../components/trustpilot/trustBoxComponent.tsx";
import ScrollToTop from "../../components/ScrollToTop.tsx";
import IconArrow from "../../components/icons/IconArrow.tsx";

export default function TrustpilotPage() {
    setTitleAndMetaDescription("Hiper på Trustpilot - vi er bedst i kategorien internetudbydere", "Vi elsker internet og tilfredse kunder, og af den grund er vi meget stolte af vores anmeldelser på Trustpilot. Bliv en af vores tilfredse kunder i dag.")
    useDatalayer()
    ScrollToTop()

    return (
        <>
            <section className="content content--narrow content--trustpilot">
                <div className="blurb">
                    <h1 className="heading heading--big">Hiper på Trustpilot</h1>
                    <p>
                        <Link to={Routing.About.Index} className="icon-link icon-link-left icon-link-rotate-180 back-link-widget">
                            <Icon component={IconArrow}/> <span className="text">Tilbage</span>
                        </Link>
                    </p>
                </div>
                <img src={imageMap.home.router_hug} alt="Hos Hiper elsker vi Trustpilot anmeldelser"/>
            </section>

            <section className="content content--wide content--trustpilot">
                <div className="blurb">
                    <h2 className="heading heading--small">Hiper er blandt de bedste i kategorien Internetudbyder på Trustpilot</h2>
                    <p>
                        Hos Hiper <strong>elsker</strong> vi <Link to={Routing.Index}>internet</Link> og tilfredse kunder, derfor betyder alle
                        anmeldelser på <a href={'https://dk.trustpilot.com/review/hiper.dk'} target={'_blank'}>Trustpilot</a> rigtig meget for os.
                    </p>
                    <p>
                        Vi har altid fokus på, at vores
                        kunder får den bedst mulige internetoplevelse, og derfor arbejder vi hver dag
                        på at levere den bedste internetforbindelse.
                        Læs vores Hiper anmeldelser lige her.
                    </p>
                </div>
            </section>

            <section className="content content--wide">
                <TrustBox templateId={"539adbd6dec7e10e686debee"} height={"720px"}/>
            </section>
        </>
    )
}
